import { leadsDataSourceMap } from "../../types/leadsFilterBuildContext";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilterGroup } from "../defineLeadsFilterGroup";

import createSignalsFilter from "./factory";

/**
 * One card per signal type. A group rather than a single-key definition because the member keys are
 * predicate-routed (`signals<Type>`) and their membership is only known at runtime — the account's
 * entitlements decide which types `signalsListViewModel` reports at all.
 */
export const signalsGroupDefinition = defineLeadsFilterGroup({
    key: "signals",
    category: leadsFilterCategoryMap.signals,
    // `technologies` is not read here: it names the saved technology signals these cards list
    // (`useUISignals` → `technologyUISignalNameBuilder`), which fall back to blank names without it.
    requires: [leadsDataSourceMap.signals, leadsDataSourceMap.technologies],

    render: (ctx) => ctx.signalsListViewModel.entries.map(createSignalsFilter),
});
